import {createContext} from 'react'
import {ModalMaintenanceHandler} from 'types'

export const ModalMaintenanceContext = createContext<ModalMaintenanceHandler | undefined>(
  undefined,
)
